class SectionSix {
  constructor () {
    this.$android = $('#sectionSix .android')
    this.$iphone = $('#sectionSix .iphone')
    
    this.init()
  }
  
  init () {
    //  初始化手机图片
    this._initPhoneImg()
  }
  
  /**
   * 初始化手机图片
   * @private
   */
  _initPhoneImg () {
    let iphone = this.$iphone.data('img')
    let android = this.$android.data('img')
    this.$iphone.append(`<img class="iphone--image" src="${iphone}?random=${window.randomString}" />`)
    this.$android.append(`<img class="android--image" src="${android}?random=${window.randomString}" />`)
  }
}

export default SectionSix
